import { SnackBar } from '@common/Snackbars/Snackbar';

export const onErrorShow = (message: string) => SnackBar('error', message);
